<template>
  <div v-loading="loading" class="nx-page nx-report-page kanban-equipment-alarm">

    <el-form inline class="filter-bar" size="small" :model="filters">
      <el-form-item label="区域">
        <el-select v-model="filters.area" clearable placeholder="全部" style="width: 140px">
          <el-option v-for="a in areaOptions" :key="a" :label="a" :value="a" />
        </el-select>
      </el-form-item>
      <el-form-item label="类型">
        <el-select v-model="filters.type" clearable placeholder="全部" style="width: 140px">
          <el-option v-for="t in typeOptions" :key="t" :label="t" :value="t" />
        </el-select>
      </el-form-item>
      <el-form-item label="紧急程度">
        <el-select v-model="filters.urgency" clearable placeholder="全部" style="width: 130px">
          <el-option label="紧急" value="紧急" />
          <el-option label="一级预警" value="一级预警" />
          <el-option label="二级预警" value="二级预警" />
          <el-option label="三级预警" value="三级预警" />
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="applyFilter">查询</el-button>
        <el-button @click="resetFilter">重置</el-button>
      </el-form-item>
    </el-form>

    <div class="kb-two-col">
      <div class="kb-section">
        <div class="kb-section-head">
          <span>隐患列表</span>
          <div>
            <el-button size="mini" icon="el-icon-arrow-left" @click="prevCard">上一项</el-button>
            <el-button size="mini" icon="el-icon-arrow-right" @click="nextCard">下一项</el-button>
          </div>
        </div>
        <div class="kb-carousel-track">
          <div
            v-for="h in filteredHazards"
            :key="h.id"
            class="kb-alarm-card"
            :class="{ 'is-active': selectedId === h.id }"
            @click="selectHazard(h.id)"
          >
            <div class="kb-alarm-card-img">⚠️</div>
            <div class="kb-alarm-card-body">
              <div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:8px;">
                <el-tag :type="urgencyType(h.urgency)" size="mini">{{ h.urgency }}</el-tag>
                <span style="font-size:12px;color:#5b6e8c;">{{ h.area }}</span>
              </div>
              <div style="font-size:14px;font-weight:500;margin-bottom:8px;">{{ h.desc }}</div>
              <div style="font-size:12px;color:#5b6e8c;">{{ h.reporter }} ({{ h.reporterId }})</div>
              <div style="font-size:11px;color:#8ba0bc;margin-top:6px;">{{ h.reportTime }}</div>
            </div>
          </div>
        </div>
      </div>

      <div class="kb-section">
        <div class="kb-section-head">
          <span>闭环管理</span>
          <small v-if="selected">隐患 #{{ selected.id }} · {{ selected.process && selected.process.status }}</small>
        </div>
        <div v-if="!selected" class="kb-floor-placeholder">请选择左侧隐患卡片</div>
        <div v-else-if="selected.process && selected.process.stages">
          <div v-for="(st, idx) in selected.process.stages" :key="idx" class="kb-closure-step">
            <div class="kb-closure-icon" :class="stageIconClass(st.status)">
              <i :class="stageIcon(st.status)" />
            </div>
            <div>
              <div style="font-weight:600;">{{ st.name }}</div>
              <div class="kb-kpi-sub">处理人: {{ st.handler || '--' }}</div>
              <div class="kb-kpi-sub">措施: {{ st.measure || '暂无' }}</div>
            </div>
          </div>
          <el-button type="default" size="small" style="width:100%;margin-top:12px" @click="traceVisible = true">
            查看处置过程留痕
          </el-button>
        </div>
        <div v-else class="kb-floor-placeholder">接口未返回 process 结构</div>
      </div>
    </div>

    <el-dialog title="处置过程留痕" :visible.sync="traceVisible" width="480px" append-to-body>
      <div v-if="selected">
        <div v-for="(t, i) in selected.traces" :key="i" style="border-bottom:1px solid #eef2f6;padding:10px 0;">
          <div style="font-size:11px;color:#8ba0bc;">{{ t.time }}</div>
          <div><strong>{{ t.operator }}</strong>：{{ t.action }}</div>
          <div style="font-size:12px;">备注：{{ t.remark || '—' }}</div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import NxReportHeader from '@/components/nx/report/NxReportHeader.vue'
import { fetchEquipmentAlarm, fetchEquipmentAlarmDetail } from './api'

export default {
  name: 'KanbanEquipmentAlarm',
  components: { NxReportHeader },
  data() {
    return {
      loading: false,
      hazards: [],
      filteredHazards: [],
      selectedId: null,
      filters: { area: '', type: '', urgency: '' },
      traceVisible: false
    }
  },
  computed: {
    areaOptions() {
      return [...new Set(this.hazards.map((h) => h.area))]
    },
    typeOptions() {
      return [...new Set(this.hazards.map((h) => h.type))]
    },
    selected() {
      return this.filteredHazards.find((h) => h.id === this.selectedId) || null
    }
  },
  mounted() {
    this.loadData()
  },
  methods: {
    async loadData() {
      this.loading = true
      try {
        const d = await fetchEquipmentAlarm({ page: 1, size: 50 })
        this.hazards = d.hazards || []
        this.applyFilter()
        this.loadSelectedDetail(this.selectedId)
      } catch (e) {
        this.$message.error((e && e.message) || '加载失败')
      } finally {
        this.loading = false
      }
    },
    urgencyType(u) {
      if (u === '紧急') return 'danger'
      if (u && u.includes('一级')) return 'warning'
      return 'info'
    },
    applyFilter() {
      const f = this.filters
      this.filteredHazards = this.hazards.filter((h) => {
        if (f.area && h.area !== f.area) return false
        if (f.type && h.type !== f.type) return false
        if (f.urgency && h.urgency !== f.urgency) return false
        return true
      })
      this.selectedId = this.filteredHazards[0] ? this.filteredHazards[0].id : null
      this.loadSelectedDetail(this.selectedId)
    },
    resetFilter() {
      this.filters = { area: '', type: '', urgency: '' }
      this.applyFilter()
    },
    selectHazard(id) {
      this.selectedId = id
      this.loadSelectedDetail(id)
    },
    prevCard() {
      const arr = this.filteredHazards
      if (!arr.length) return
      const i = arr.findIndex((h) => h.id === this.selectedId)
      if (i <= 0) this.selectedId = arr[arr.length - 1].id
      else this.selectedId = arr[i - 1].id
      this.loadSelectedDetail(this.selectedId)
    },
    nextCard() {
      const arr = this.filteredHazards
      if (!arr.length) return
      const i = arr.findIndex((h) => h.id === this.selectedId)
      if (i < 0 || i >= arr.length - 1) this.selectedId = arr[0].id
      else this.selectedId = arr[i + 1].id
      this.loadSelectedDetail(this.selectedId)
    },
    async loadSelectedDetail(id) {
      if (!id) return
      const target = this.hazards.find((h) => h.id === id)
      if (!target || target.detailLoaded || target.detailLoading) return
      this.$set(target, 'detailLoading', true)
      try {
        const detail = await fetchEquipmentAlarmDetail(id)
        const merged = {
          ...target,
          ...detail,
          id: target.id,
          detailLoaded: true
        }
        this.replaceHazard(id, merged)
      } catch (e) {
        console.warn(e)
      } finally {
        const latest = this.hazards.find((h) => h.id === id)
        if (latest) this.$set(latest, 'detailLoading', false)
      }
    },
    replaceHazard(id, hazard) {
      const replace = (list) => {
        const index = list.findIndex((h) => h.id === id)
        if (index > -1) this.$set(list, index, hazard)
      }
      replace(this.hazards)
      replace(this.filteredHazards)
    },
    stageIconClass(status) {
      if (status === 'done') return 'is-done'
      if (status === 'active') return 'is-active'
      return 'is-pending'
    },
    stageIcon(status) {
      if (status === 'done') return 'el-icon-check'
      if (status === 'active') return 'el-icon-loading'
      return 'el-icon-time'
    }
  }
}
</script>

<style lang="scss" scoped>
@import './index.scss';
</style>
